module.exports = __webpack_public_path__ + "static/media/about_us_havilla_gifts.8f3e67d3.svg";